<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="overseasEvent"
        :is-no-changes="isNoChanges"
        @save="saveOverseasEvent"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="workTypeRusName(workTypeName.OverseasEvent)" />

          <AuthorsCard
            class="mt-4"
            :selected-item.sync="overseasEvent.commonWork.authors"
            :is-show-mode="isShowMode"
            hide-share
            hide-not-found-author
            @updateInvalid="updateAuthorsInvalid"
          />

          <OverseasEventCard
            class="mt-4"
            title="Основная информация"
            :is-show-mode="isShowMode"
            :selected-item.sync="overseasEvent"
            @updateInvalid="updateOverseasEventInvalid"
          />

          <CommentCard
            v-if="Boolean(overseasEvent.commonWork.comment)"
            class="mt-4"
            :comment="overseasEvent.commonWork.comment"
          />

          <CreatorCard :creator-name="overseasEvent.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { overseasEventApi } from '@/api'
import { OverseasEvent } from '../../models'
import TitleCard from '@/components/Works/elements/TitleCard'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import OverseasEventCard from '../../components/Works/OverseasEvent/OverseasEventCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { dictionaryNames, workMode, workTypeName } from '@/scripts/consts'

export default {
  name: 'OverseasEventPage',

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.OverseasEvent)
    }
  },

  components: {
    CreatorCard,
    WorkTitleCard,
    CommentCard,
    OverseasEventCard,
    AuthorsCard,
    TitleCard
  },

  mixins: [workListHeight],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.getData()
  },

  data: () => ({
    overseasEvent: new OverseasEvent(),
    dataLoaded: false,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    overseasEventInvalid: false,
    authorsInvalid: false,
    saveBtnLoading: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.overseasEventInvalid || this.authorsInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode) await this.getDictionaries([dictionaryNames.ParticipationKind])
      await this.getWorkTypes()
      await this.getOverseasEvent()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getOverseasEvent() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = this.$route.params?.id ? await overseasEventApi.get(this.$route.params?.id) : null
          if (data) this.overseasEvent = new OverseasEvent(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async saveOverseasEvent(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.overseasEvent.id)
          this.overseasEvent.commonWork.workType = this.workTypeByName(workTypeName.OverseasEvent)

        const body = this.overseasEvent.getForAPI()

        const data = this.overseasEvent.id ? await overseasEventApi.update(body) : await overseasEventApi.create(body)

        if (!this.overseasEvent.id) await this.$router.replace('/works/overseasEvent/edit/' + data.id)

        this.overseasEvent = new OverseasEvent(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },

    updateOverseasEventInvalid(val) {
      this.overseasEventInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.saveOverseasEvent
    }
  }
}
</script>

<style scoped></style>
